import {
    Card,
    CardContent,
    CardDescription,
    CardFooter,
    CardHeader,
    CardTitle,
} from "@/components/ui/card"

import { BrainCircuit,Crosshair,ScrollText,Search,Store } from "lucide-react";


export const CarriSteps = () => {
    return (
        <div className="flex flex-row items-center justify-evenly gap-8 flex-wrap mx-auto">
            <Card className="text-center min-w-72 max-w-72 min-h-80">
                <CardHeader>
                    <CardTitle className="text-center"></CardTitle>
                    <CardDescription className="russo-one-regular text-xl text-primary/80">Crea tu Lista de Compras</CardDescription>
                </CardHeader>
                <CardContent className="flex  flex-col w-full justify-center items-center gap-4">
                    <div className="rounded-full p-4 bg-primary/80 text-white">
                        <ScrollText className="w-10 h-10"/>
                    </div>

                    <p className="text-sm font-semibold text-muted-foreground">Arma tu lista, seleccionando los productos que quieras comprar.</p>
                </CardContent>
                <CardFooter>
                </CardFooter>
            </Card>
            <Card className="text-center min-w-72 max-w-72 min-h-80">
                <CardHeader>
                    <CardTitle className="text-center"></CardTitle>
                    <CardDescription className="russo-one-regular text-xl text-foreground/80 ">Analizamos tu lista de compras</CardDescription>
                </CardHeader> 
                <CardContent className="flex  flex-col w-full justify-center items-center gap-4">
                    <div className="rounded-full p-4 bg-foreground/80 text-white">
                        <BrainCircuit className="w-10 h-10"/>
                    </div>
                    <p className="text-sm font-semibold text-muted-foreground">Con un clic, comparamos precios y descuentos para determinar la combinación más eficiente por tienda.</p>
                </CardContent>
                <CardFooter>
                </CardFooter>
            </Card>
            <Card className="text-center min-w-72 max-w-72 min-h-80">
                <CardHeader>
                    <CardTitle className="text-center"></CardTitle>
                    <CardDescription className="russo-one-regular text-xl secondary-color-text">Finaliza y paga en cada tienda</CardDescription>
                </CardHeader>
                <CardContent className="flex  flex-col w-full justify-center items-center gap-4">
                    <div className="rounded-full p-4  brand-bg text-white">
                        <Crosshair  className="w-10 h-10"/>
                    </div>
                    <p className="text-sm font-semibold text-muted-foreground">Te indicamos donde comprar, ahorrando lo máximo posible. Considerando costos de despachos, precios y promociones.</p>
                </CardContent>
                <CardFooter>
                </CardFooter>
            </Card>      
        </div>
    );
};
